
export const isEmpty = (value: string): boolean => {
    return value === ``
}

export const isNotEmpty = (value: string): boolean => {
    return value !== ``
}

export const capitaliseText = (value: string): string => {
    return value.toUpperCase()
}

export const hashString = async (value: string): Promise<string> => {
    const encoder = new TextEncoder()
    const data = encoder.encode(value)
    const hashBuffer = await crypto.subtle.digest(`SHA-256`, data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    // eslint-disable-next-line no-magic-numbers
    return hashArray.map(b => b.toString(16).padStart(2, `0`)).join(``)
}